import { z } from 'zod'

export const configSchema = z.strictObject({
  fingerprintJs: z.object({
    apiKey: z.string(),
    endpoint: z.string(),
    agentDownloadPath: z.string(),
    agentGetResultPath: z.string(),
    agentBehaviorPath: z.string(),
  }),
})

export type Config = z.infer<typeof configSchema>
